import React,{useState,useEffect,useCallback} from "react";
import Webcam from "react-webcam";
import {Input,message,Modal,Image,Button,Row,Col,Upload} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {cancelTokenSource} from "../hooks/hooks";
import { useTranslation } from 'react-i18next';
import config from "../business/config.json";
import {useAxios} from "../hooks/hooks";
import {useKeycloak} from "@react-keycloak/web";

const { Dragger } = Upload;

function PhotoComponent(props){
    const axios = useAxios();
    const { keycloak } = useKeycloak()


    const source = cancelTokenSource;
	const {t} = useTranslation();
      const [camera,setCamera] = useState(null);
      const [value,setValue] = useState(null);
      const [uploadFile,setUploadFile] = useState(true);
      const [selfie,setSelfie] = useState(false);
      const [videoConstraints, setVideoConstraints] = useState({
        width: 1280,
        height: 720,
        facingMode: { exact: "environment" }
      });

  const webcamRef = React.useRef(null);


  const uploadProps = {
    name: 'file',
    multiple: true,
    action: config.api_domain+'/picture',
    headers: {
        Authorization: "Bearer " + keycloak?.token
    },
    data:{
      entity:"photo"
    },
    onChange(info) {
      const { status } = info.file;
      if(status === "done"){
        if (info.file.response.success === true) {
            console.log(info.file.response);
          message.success(t("Filename file uploaded successfully",{filename:info.file.name}));
            console.log(props)
          if (uploadFile && typeof props.currentproject !== "undefined") {
              console.log("posting update")
              axios.current.post(
                  "/photos",
                  {
                      id_project: props.currentproject,
                      is_report_photo:false,
                      url_photo: config.api_domain+"/business/database/photo/img/"+info.file.response.filename
                  }

              )
          }
          saveChanges(info.file.response.filename);
        }else{
          message.error(t("Filename file upload failed",{filename:info.file.name}));
        }
      } else if(status === "error" ) {
      	message.error(t("Filename file upload failed",{filename:info.file.name}));
      }
    }
  };

  const toggleCameraMode = function(){
    var constraints = JSON.parse(JSON.stringify(videoConstraints));
    constraints.facingMode = selfie ? {exact:"environment"} : "user" ;
    setVideoConstraints(constraints);
    setSelfie(selfie === true ? false : true);
  }

  const uploadPreview = async file => {
    let src = file.url;
    if (!src) {
      src = await new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

const updateSrc = function(e){
    setValue(e.target.value);
}

  const saveChanges = function(v){
    v = props.dir+"photo"+"/img/"+v;
    setValue(v);
  }

  const capture = useCallback(() => {
		const imageSrc = webcamRef.current.getScreenshot();
		setValue(imageSrc);
		axios.current.post(
			"/picture/base64",
			{
				image:imageSrc,
				entity:"photo"
			},
			{
				cancelToken: cancelTokenSource.token
			}
		).then(function(response){
			const data = response.data;
			if(data.error){
				message.error(t("Capture upload failed."));
				return;
			}
			saveChanges(data.filename);
			message.success(t("Capture uploaded successfully.")); 
		}).catch(function(e){
			message.error(t("Capture upload failed."));
		});
	},[webcamRef,t]);
	
  useEffect(() => {
    props.onChange({
      target:{
        id:props.id,
        value:value
      },
      currentTarget:{
        id:props.id,
        value:value
      }
    });
	},[value]);

	useEffect(() => {
		setValue(props.value);
		navigator.mediaDevices.enumerateDevices();
		return (() => {
			source.cancel();
		});
	},[]);

  if(camera === null || camera === true){
    return (
      <>
				<Row>
					<Col span={24}>
						<Input type="text" defaultValue={props.value} onChange={updateSrc}/>
					</Col>
				</Row>
        <Row justify="center" style={{width:"100%",background:"#CCC"}}>
          <Col span={6} style={{background:"#CCC",textAlign:"center",paddingTop:"10px"}}>
            <Image src={value} style={{width:"120px",height:"auto"}} />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Button
              block
              size="large"
              icon={<FontAwesomeIcon className="fa-fw" icon="camera" />}
              onClick={(e) => setCamera(true)}
            >
              {t("Camera")}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              block
              size="large"
              icon={<FontAwesomeIcon className="fa-fw" icon="image" />}
              onClick={(e) => setCamera(false)}
            >
              {t("Picture")}
            </Button>
          </Col>
        </Row>
        <Modal
          width="100%"
          title={t("Camera")}
          open={camera}
          onCancel={(e) => setCamera(null)}
          onOk={(e) => setCamera(null)}
          footer={null}
        >
          {value === null && (
            <>
              <Row align="middle" justify="center">
                <Col span={4} justify="center" align="middle">
                  <Button
                    shape="circle"
                    size="large"
                    type="primary"
                    block
                    icon={
                      <FontAwesomeIcon icon={selfie ? "user-circle" : "tree"} className="fa-fw" />
                    }
                    onClick={(e) => toggleCameraMode()}
                  >
                  </Button>
                </Col>
                <Col span={16}>
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    width={"100%"}
                    videoConstraints={videoConstraints}
                  />
                </Col>
                <Col span={4} justify="center" align="middle">
                  <Button
                    shape="circle"
                    block
                    danger
                    type="primary"
                    size="large"
                    icon={<FontAwesomeIcon icon="camera" className="fa-fw" />}
                    onClick={capture}
                  >
                  </Button>
                </Col>
              </Row>
            </>
          )}
          {value != null && (
            <>
        			<Row justify="center" style={{background:"#CCC"}}>
          			<Col span={6} style={{background:"#CCC"}}>
            			<Image src={value} width="100%" />
          			</Col>
        			</Row>
              <Row>
                <Col span={24}>
                  <Button
                    block
                    danger
                    type="primary"
                    size="large"
                    icon={<FontAwesomeIcon icon="camera" className="fa-fw" />}
                    onClick={(e) => setValue(null)}
                  >
                    {t("Capture another picture")}
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Button
                    block
                    type="primary"
                    size="large"
                    icon={<FontAwesomeIcon icon="thumbs-up" className="fa-fw" />}
                    onClick={(e) => setCamera(null)}
                  >
                    {t("Done")}
                  </Button>
                </Col>
              </Row>
            </>
          )}
        </Modal>
      </>
    );
  }
  if(camera === false && value === null){
    return (
      <>
        <Row>
          <Col span={24}>
            <Dragger
              onPreview={uploadPreview}
              {...uploadProps}
            >
              <p className="ant-upload-drag-icon">
                <FontAwesomeIcon className="fa-4x" icon="upload" />
              </p>
              <p className="ant-upload-text">
               {t("Click or drag file to this area to upload")}
              </p>
              <p className="ant-upload-hint">
               	{t("Support for a single upload")}
              </p>
            </Dragger>
          </Col>
        </Row>
         <Row>
          <Col span={24}>
            <Button
              block
              size="large"
              icon={<FontAwesomeIcon icon="arrow-left" className="fa-fw" />}
              onClick={(e) => setCamera(null)}
            >
              {t("Back")}
            </Button>
          </Col>
        </Row>
      </>
    );
  }
  if(camera === false && value != null){
    return (
      <>
        <Row justify="center" style={{background:"#CCC"}}>
         	<Col span={6} style={{background:"#CCC"}}>
       			<Image src={value} width="100%" />
      		</Col>
        </Row>
        <Row>
          <Col span={24}>
            <Button
              block
              danger
              type="primary"
              size="large"
              icon={<FontAwesomeIcon icon="upload" className="fa-fw" />}
              onClick={(e) => setValue(null)}
            >
            	{t("Upload another picture")}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Button
              block
              size="large"
              icon={<FontAwesomeIcon icon="arrow-left" className="fa-fw" />}
              onClick={(e) => setCamera(null)}
            >
              {t("Back")}
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default PhotoComponent;
